var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, CustomElement, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './ValueDisplay.style';
/**
 * A value-display element displays text.
 * It can be used to show a value with its unit.
 * 
 * @example
 * ```html
 * <davinci-value-display>This is SICK!</davinci-value-display>
 * <davinci-value-display value="50" unit="m"></davinci-value-display>
 * ```
 * @slot { * } content of the value-display
 */

export let ValueDisplay = (_dec = Component({
  style: [style],
  tag: 'davinci-value-display'
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = (_temp = class ValueDisplay extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "unit", _descriptor, this);

    _initializerDefineProperty(this, "label", _descriptor2, this);

    this.internalValue = '';

    this.onSlotChange = _event => {
      if (this.textContent) {
        this.value = this.textContent;
      }
    };
  }

  /**
   * Get the value.
   */
  get value() {
    // tslint:disable-line
    return this.internalValue;
  }
  /**
   * Set the value.
   */


  set value(value) {
    // tslint:disable-line
    this.internalValue = value;
  }
  /**
   * Specifies the unit after the value.
   */


  // tslint:disable-line
  componentConnected() {
    if (!this.value && this.textContent) {
      this.value = this.textContent;
    }
  }

  render() {
    return html`
      <div class="wrapper">
        <div>
          <label class="label">${this.label}</label>
        </div>
        <span class="value">${this.internalValue}</span>
        <span class="unit">${this.unit}</span>
        <div class="slotwrapper"><slot @slotchange="${this.onSlotChange}"></slot></div>
      </div>
    `;
  }

}, _temp), (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
})), _class2)) || _class);
//# sourceMappingURL=ValueDisplay.js.map